<template>
  <!-- Dashboard Box -->
  <div class="col-xl-12">
    <div id="test1" class="dashboard-box">
      <!-- Headline -->
      <div class="headline">
        <h3>
          <i class="icon-material-outline-lock"></i>
          {{ isSecurityQuestionSet ? "Update" : "Set" }} Secret Question &
          Answer
        </h3>
      </div>

      <div class="content with-padding padding-bottom-10">
        <div class="row">
          <div class="col-xl-6">
            <div class="submit-field">
              <h5>Question</h5>
              <input
                type="text"
                class="with-border"
                placeholder="Who is the current CEO of Twitter"
              />
            </div>
          </div>

          <div class="col-xl-6">
            <div class="submit-field">
              <h5>Answer</h5>
              <input
                type="text"
                class="with-border"
                placeholder="Parag Agrawal"
              />
            </div>
          </div>

          <div class="col-xl-12">
            <a
              href="#"
              class="button ripple-effect  big "
              @click="setSecurityQuestionAndAnswer()"
              ><i class="icon-material-outline-lock mr-1"></i>
              {{ isSecurityQuestionSet ? "Update" : "Set" }} Security
              Question</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-console */
import { SET_SECURITY_QUESTION_AND_ANSWER } from "../../../core/config/endpoints/user";
import { postCall } from "../../../core/services/http.service";

export default {
  name: "UserSetSecurityQuestion",
  data() {
    return {
      isSecurityQuestionSet: false,
    };
  },
  methods: {
    setSecurityQuestionAndAnswer(request) {
      postCall(SET_SECURITY_QUESTION_AND_ANSWER, {
        security_question: request.securityQuestion,
        security_answer: request.securityAnswer,
      })
        .then(response => {
          console.log(response);
        })
        .catch(error => {
          this.$toast.error(`${error.response.data.message}`);
        })
        .finally(() => {
          this.$store.commit("setIsLoaded", false);
        });
    },
  },
};
</script>

<style></style>
